import { __generator } from "tslib";
import { put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { getBrowseDeviationStreamId } from '../helpers';
import { getSearchQuery } from '../selectors';
export default function () {
    var searchQuery, streamId, isFetching;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(function (state) {
                    return getSearchQuery(state);
                })];
            case 1:
                searchQuery = _a.sent();
                streamId = getBrowseDeviationStreamId(searchQuery);
                return [4 /*yield*/, select(selectors.isFetching, streamId)];
            case 2:
                isFetching = _a.sent();
                if (isFetching) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, put(withOffset.actions.fetch(streamId))];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=fetchMoreBrowseDeviations.js.map